module.exports = __webpack_public_path__ + "img/play.7c57d921.png";